module.exports = __webpack_public_path__ + "img/fashion_21.27c31c76.jpg";